var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.block.data.embed)?_c('div',{staticClass:"entry-gallery embed-wrapper w-mb2"},[_c('div',{ref:"player",attrs:{"data-plyr-provider":_vm.block.data.service,"data-plyr-embed-id":_vm.block.data.embed}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }